import { Directive, ElementRef, HostListener } from '@angular/core';

import * as screenfull from 'screenfull';

@Directive({
  selector: '[appToggleFullscreen]'
})
export class ToggleFullscreenDirective {
  constructor(private elements: ElementRef) { }

  @HostListener('click') onClick() {
    if (screenfull.enabled) {
      (this.elements).nativeElement.querySelector('.feather').classList.toggle('icon-size-fullscreen');
      (this.elements).nativeElement.querySelector('.feather').classList.toggle('icon-size-actual');

      screenfull.toggle();
    }
  }
}
